import { render, staticRenderFns } from "./seoBoard.vue?vue&type=template&id=c18b69a2&scoped=true"
import script from "./seoBoard.vue?vue&type=script&lang=js"
export * from "./seoBoard.vue?vue&type=script&lang=js"
import style0 from "./seoBoard.vue?vue&type=style&index=0&id=c18b69a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18b69a2",
  null
  
)

export default component.exports